import { createSelector } from 'reselect';

const checkState = (state) => state;

const selectInvestors = createSelector(checkState, (state) => state.get('investors'));

// --- Investor Outreach subscription entitlement (ATAI-260 / S7) ---
const selectEntitlement = createSelector(selectInvestors, (state) => state.get('entitlement'));

export const selectInvestorOutreachEntitlementLoading = createSelector(selectEntitlement, (e) =>
  e.get('loading')
);

export const selectInvestorOutreachEntitlementLoaded = createSelector(selectEntitlement, (e) =>
  e.get('loaded')
);

export const selectInvestorOutreachEntitled = createSelector(selectEntitlement, (e) =>
  e.get('entitled')
);

export const selectInvestorOutreachEntitlementError = createSelector(selectEntitlement, (e) =>
  e.get('error')
);

export const selectInvestorOutreachStatus = createSelector(selectEntitlement, (e) =>
  e.get('status')
);

export const selectInvestorOutreachEndDate = createSelector(selectEntitlement, (e) =>
  e.get('endDate')
);

export const selectInvestorOutreachConnectCancelledWithIo = createSelector(selectEntitlement, (e) =>
  e.get('connectCancelledWithIo')
);

export const selectInvestorOutreachEndedDate = createSelector(selectEntitlement, (e) =>
  e.get('endedDate')
);

export const selectSubject = createSelector(selectInvestors, (state) => state.get('subject'));

export const selectSubjectLabel = createSelector(selectInvestors, (state) =>
  state.get('subjectLabel')
);

export const selectSubjectSuggestions = createSelector(selectInvestors, (state) =>
  state.get('suggestions')
);

export const selectSubjectSuggestionsLoading = createSelector(selectInvestors, (state) =>
  state.get('suggestionsLoading')
);

export const selectSubjectSuggestionsQuery = createSelector(selectInvestors, (state) =>
  state.get('suggestionsQuery')
);

export const selectRecentSubjects = createSelector(selectInvestors, (state) =>
  state.get('recentSubjects')
);

export const selectInvestorFilters = createSelector(selectInvestors, (state) =>
  state.get('filters')
);

// The PRD fixes the subject as a property address, so the search CTA only
// enables once a suggestion has resolved to a property.
export const selectSubjectComplete = createSelector(selectSubject, (subject) =>
  Boolean(subject && subject.propertyId)
);

// True when the subject was auto-picked because the suggestion list came back
// with a single result, rather than clicked by the user.
export const selectSubjectPreselected = createSelector(selectInvestors, (state) =>
  state.get('subjectPreselected')
);

export const selectInvestorResults = createSelector(selectInvestors, (state) =>
  state.get('investors')
);

export const selectInvestorTotal = createSelector(selectInvestors, (state) => state.get('total'));

export const selectLoading = createSelector(selectInvestors, (state) => state.get('loading'));

export const selectError = createSelector(selectInvestors, (state) => state.get('error'));

export const selectInvestorProperties = createSelector(selectInvestors, (state) =>
  state.get('properties')
);

export const selectSubjectLocation = createSelector(selectInvestors, (state) =>
  state.get('subjectLocation')
);

// True when the service truncated the result set.
export const selectInvestorCapped = createSelector(selectInvestors, (state) => state.get('capped'));

// Vendor warnings passed straight through from the search response.
export const selectInvestorWarnings = createSelector(selectInvestors, (state) =>
  state.get('warnings')
);

// True once a search has come back, so a zero-result search can be told apart
// from the pre-search state (both have total 0).
export const selectInvestorSearched = createSelector(selectInvestors, (state) =>
  state.get('searched')
);

// True when a search is pending: an address was picked or a filter changed after a search.
export const selectInvestorStale = createSelector(selectInvestors, (state) => state.get('stale'));
